import {Component, LayoutOptions} from "@mecatran-components/component";
import viewTemplate from "../templates/view.njk";
import {DomUtils} from "../services/utils/index.web.mjs";


export class View extends Component{
    constructor(){
        super();

        this.initView()
    }

    // ==========
    // private
    // ----------
    initView(){
        var layout = new LayoutOptions(viewTemplate);
        this.setContentOptions(layout);
        this.build();
    }

    // ==========
    // overload
    // ----------
    createContainerNode(){
        var div = View.createElement('div','my-view');
        return div;
    }

    createMapNode(){
        var div = View.createElement('div','map');
        return div;
    }

    createContentNode(){
        var map = View.createElement('div','map');
        var headerPanel = View.createElement('div','header-panel');
        var bodyPanel = View.createElement('div','body-panel');
        var footerPanel = View.createElement('div','footer-panel');
        return [map, headerPanel, bodyPanel, footerPanel ]     
    }

    /*
    createContentNode(){
        var map = View.createElement('div','map');
        var div = View.createElement('div','lateral-panel');
        var input = View.createElement('input','lateral-panel-input');
        input.setAttribute('type','checkbox');
        var label = View.createElement('label','lateral-panel-label');
        label.setAttribute('for','lateral-panel-input');
        var div2 = View.createElement('div','lateral-panel-bloc');
        div.appendChild(input);
        div.appendChild(label);
        div.appendChild(div2);
        div.appendChild(div2);
        return [map, div];     
    }
    */
    // ==========
    // public 
    // ----------
    /**
     * 
     * @param panel - string ['header','body','footer']
     */
    hide(selector){
        var domNode = this.getDomNode();
        var node = DomUtils.getFirstChild(selector, domNode);
        node.style.display = "none";
    }

    show(selector){
        var domNode = this.getDomNode();
        // var selector = `${panel}-panel`;
        var node = DomUtils.getFirstChild(selector, domNode);
        node.style.display = ""; 
    }

    /*
    clear(selector){
        var domNode = this.getDomNode();
        var node = DomUtils.getFirstChild(selector,domNode)
        DomUtils.removeChilds(node);
    }
    */

    setHeight(selector, height){
        var domNode = this.getDomNode();
        var node = DomUtils.getFirstChild(selector, domNode);
        node.style.height = height;
    }

    setTopPosition(selector, top){
        var domNode = this.getDomNode();
        var node = DomUtils.getFirstChild(selector, domNode);
        node.style.top = top;     
    }



    // ==========
    // static 
    // ----------

    static createElement(type,id){
        var element = document.createElement(type);
        element.id = id; 
        return element; 
    }
}

/*
<div id="lateral-panel">
  <input id="lateral-panel-input" type="checkbox">
  <label id="lateral-panel-label" for="lateral-panel-input"></label>
  <div id="lateral-panel-bloc">
    content
  </div>
</div>
*/